import api from 'api'

export type UpdateIndeedFlexCompanyParams = {
  indeedFlexCompanyId: number
  ifClientId?: number
  canCreateShifts?: boolean
  fileHandleId?: number | null
  shiftNotificationTitle?: string | null
  shiftNotificationMessage?: string | null
  shiftNotificationDeliveryHour?: number | null
}

export type UpdateIndeedFlexCompanyResponse = {
  updatedAt: string
}

export const updateIndeedFlexCompany = async ({
  indeedFlexCompanyId,
  ...body
}: UpdateIndeedFlexCompanyParams): Promise<UpdateIndeedFlexCompanyResponse> => {
  const result = await api.patch<UpdateIndeedFlexCompanyResponse>(
    `/admin/indeed_flex/companies/${indeedFlexCompanyId}`,
    body
  )
  return result.data
}
